import { useContext,useEffect } from "react";
import { useNavigate  } from 'react-router-dom';

import { AuthContext } from '../store/AuthContext';

function PrivateRoute({ children }) {

  const navigate = useNavigate();
  const { user, login } = useContext(AuthContext);

  useEffect(() => {

    if (window.performance) {
      if (performance.navigation.type === 1) {
        localStorage.clear();
        navigate('/login');
      }
    }
  //eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  if (user && login) {
    return children;
  }

  return navigate('/');
}

export default PrivateRoute